export const storage = {
  namespaced: true,
  actions: {
    async upload(
      { dispatch },
      {
        file,
        metadata = null,
        baseDir = null,
        prefix = null,
        autoGenerateKey = false,
        onUploadProgress = () => {},
      }
    ) {
      if (!(file instanceof File)) {
        throw new TypeError('must be File instance')
      }
      const data = new FormData()
      data.append('file', file)
      if (metadata != null) {
        data.append('metadata', metadata)
      }
      if (baseDir != null) {
        data.append('base_dir', baseDir)
      }
      if (prefix != null) {
        data.append('prefix', prefix)
      }
      data.append('auto_generate_key', autoGenerateKey)
      try {
        const response = await axios.post(`/api/storages`, data, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress,
        })
        return response.data.data
      } catch (error) {
        dispatch(
          'handleError',
          { key: 'storage/upload', error },
          { root: true }
        )
      }
    },
  },
}
